import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { StyledSkipLink } from '../styles';
import { useSkipLinkBehavior } from '../externals';
/**
 * For creating a skip-link within the current document. You may want to wrap this in a relatively-positioned container, but this is not required.
 *
 * ```
 * <SkipLink href="#main">Skip to main content</SkipLink>
 * <!-- other stuff -->
 * <main id="main">Hello world</main>
 * ```
 *
 * Why all this extra stuff? See: https://axesslab.com/skip-links/
 */

var SkipLink = function SkipLink(props) {
  var mainContentId = props.mainContentId,
      dataTest = props['data-test'],
      anchorProps = _objectWithoutProperties(props, ["mainContentId", "data-test"]);

  var _useSkipLinkBehavior = useSkipLinkBehavior(props),
      skipLinkBehavior = _extends({}, _useSkipLinkBehavior);

  return /*#__PURE__*/React.createElement(StyledSkipLink, _extends({}, anchorProps, skipLinkBehavior, {
    href: "#".concat(mainContentId),
    "data-test": dataTest ? dataTest : undefined
  }));
};

SkipLink.defaultProps = {
  showOnFocusOnly: false
};
export default SkipLink;